module.exports = __webpack_public_path__ + "static/media/Edit_task.2d762526.png";